module.exports = __webpack_public_path__ + "img/azerbaijan.dc6b36a.webp";